import React from 'react'
import VersionAuditing from './VersionAuditing'

export default function Applications({ applications, appVersionOptions }) {
  const columns = [
    { id: 'name', header: 'Name', cell: 'name' },
    { id: 'owner', header: 'Owner', cell: 'owner' },
    { id: 'email', header: 'Technical Contact Email', cell: 'email' },
    { id: 'createdAt', header: 'Created At', cell: 'created_at' },
  ]

  return (
    <VersionAuditing
      appVersionOptions={appVersionOptions}
      auditing="Oauth Applications"
      columns={columns}
      data={applications}
    />
  )
}
